































































































import { Component, Vue } from "vue-property-decorator";

import { getReports, createReport } from "@/services";
import { notifyError, notifySuccess } from "@/common/notify";
import { Report } from "@/interfaces";
import { sortBy } from "lodash";

import { date } from "quasar";

@Component
export default class DownloadCsvXls extends Vue {
  loading = false;

  elements: Report[] = [];

  filteredData: Report[] = [];

  searchText = "";

  async mounted() {
    try {
      this.elements = this.filteredData = sortBy(await getReports(), "updated_at");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile reperire i dati aggregati!");
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.elements.filter(element =>
        element.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.elements;
    }
  }

  getDate(element: Report) {
    return date.formatDate(element.updated_at, "DD/MM/YYYY HH:mm");
  }

  async doDataExtraction() {
    try {
      this.$q.loading.show({ message: "Estrazione csv/xls in corso" });
      const result = await createReport();
      this.elements.push(result);
      this.filteredData = this.elements;
      this.searchText = "";
      notifySuccess("Estrazione avvenuta con successo!");
    } catch (error) {
      console.log(error);
      notifyError("Errore imprevisto, non è stato possibile generare una nuova estrazione!");
    } finally {
      this.$q.loading.hide();
    }
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
      },
      { label: "Ultima modifica", name: "date", field: "updated_at", align: "left", sortable: true },
      { name: "download", align: "center" },
    ];
  }
  
  get pagination() {
    return {
      sortBy: "date",
      descending: true,
      page: 1,
      rowsPerPage: 0,
    }  
  }
}
